export default __webpack_public_path__ + "static/media/minus.9e096b44.svg";